/**
 * Created by jaime on 03/12/2017.
 */
var Color = require('color-js')

export default {
    isMobile: function () {
        console.log(this.$vuetify.breakpoint.name)
            switch (this.$vuetify.breakpoint.name) {
                case 'xs': return true
                case 'sm': return true
                case 'md': return false
                case 'lg': return false
                case 'xl': return false
            }
    },
    push: function (param) {
            this.$router.push(param)
    },
    radialGradient: function (color) {
        return `radial-gradient(circle , ${Color(color).setAlpha(0.8).toCSS()} 10%, ${Color(color).setAlpha(0).toCSS()} 200%)`
    },
    getMainPath: function (path) {
        var endPath = path.indexOf("/", 1)
        if (endPath === -1) endPath = path.length

        var mainPath = path.substring(path.indexOf("/") + 1, endPath)
        if (mainPath === '') mainPath = 'home'
        return mainPath
    },
    Color: function () {
        return Color
    }

}